import { atom } from "recoil";
import { CrossdockStateKey } from "crossdock/base/CrossdockStateKey";

export const inboundPalletLabelBarcodeState = atom({
  key: CrossdockStateKey.MOVE_PALLET_INBOUND_PALLET_LABEL_BARCODE,
  default: "",
});
